module.exports = __webpack_public_path__ + "static/legend_customize-989ca0c9ccc89a2f2052bef9be6c9cea.png";